import { render, staticRenderFns } from "./BookCreate.vue?vue&type=template&id=0c56b88c&"
import script from "./BookCreate.vue?vue&type=script&lang=js&"
export * from "./BookCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports